/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import FuzzySearch from 'fuzzy-search';

// fuzzySearch :: Object -> (String -> [*])
export function fuzzySearch({ data = [], searchKeys = [], options = {} } = {}) {
  const searcher = new FuzzySearch(data, searchKeys, options);

  return (searchValue) => searcher.search(searchValue);
}
